import { withForm } from '@/lib/form.ts';
import { getDispenserFormOptions } from '@/features/dispensers/components/dispenser-form/config.ts';
import { Trans, useLingui } from '@lingui/react/macro';
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { ProducerService } from '@/features/producers/services/ProducerService.ts';
import { producerQueries, producerQueryKeys } from '@/features/producers/queries.ts';

export const ProducerField = withForm({
  ...getDispenserFormOptions(),
  render: function Render({ form }) {
    const { t } = useLingui();

    const queryClient = useQueryClient();

    const producerListQuery = useSuspenseQuery(producerQueries.list());

    const createProducerMutation = useMutation({
      mutationFn: ProducerService.create,
      onSuccess: () => queryClient.invalidateQueries({ queryKey: producerQueryKeys.list() }),
    });

    const producerChangeListener = () => {
      form.setFieldValue('typeId', null);
      createProducerMutation.reset();
    };

    return (
      <form.AppField
        name="producerId"
        listeners={{
          onChange: producerChangeListener,
        }}
      >
        {(field) => (
          <field.CreatableCombobox
            label={<Trans>Producer</Trans>}
            required
            loading={producerListQuery.isFetching}
            options={producerListQuery.data.result.map((p) => ({ ...p, id: `${p.id}` }))}
            getOptionLabel={(option) => option.code}
            getOptionKey={(option) => option.id}
            onCreateNew={async (input) =>
              `${(await createProducerMutation.mutateAsync({ code: input })).id}`
            }
            errorMessage={
              createProducerMutation.isError ? t`Could not create new producer` : undefined
            }
          />
        )}
      </form.AppField>
    );
  },
});
